import { useState } from 'react'
import imageBackground from '../../../assets/imgs/search.webp'
import { Search } from 'lucide-react'
import { ButtonMobile } from './components/ButtonMobile'
import { useApp } from '../../../context/App'
import { Modal } from '../../ui/Modal'

export function SearchMobile() {
	const { configDomainURL } = useApp()
	const domain = configDomainURL
	const [inputSearch, setInputSearch] = useState<string>('')
	const [quickService, setQuickService] = useState<{ label: string, url: string } | null>(null)

	const handleQuickService = (item: { label: string, url: string }) => {
		const modalServices = ['Jornais', 'Webmail']
		if (modalServices.includes(item.label)) {
			setQuickService(item)
		} else {
			window.open(item.url, "_blank")
		}
	}

	return (
		<section className="flex w-full items-center justify-center" aria-label="Busca principal">
			<div
				className="flex flex-col bg-cover bg-center w-11/12 h-[28rem] rounded-3xl items-center justify-center relative overflow-hidden shadow-xl"
				style={{
					backgroundImage: `url(${imageBackground})`,
				}}
			>
				{/* Mobile Gradient Overlay */}
				<div className="absolute inset-0 bg-gradient-to-b from-primary/90 via-primary/60 to-primary/95 dark:from-surface-dark/95 dark:via-surface-dark/70 dark:to-surface-dark/98"></div>

				<div className="relative z-10 flex flex-col w-full items-center p-6 text-center">
					<h2 className="text-white text-2xl font-bold font-roboto mb-6 drop-shadow-lg leading-tight">
						O que você procura hoje?
					</h2>

					<form
						className="flex w-full rounded-2xl h-14 bg-white dark:bg-surface-dark-alt shadow-2xl items-center overflow-hidden mb-8 ring-4 ring-white/10"
						action={`${domain}busca/${inputSearch}`}
					>
						<input
							name='search'
							type='text'
							onChange={e => setInputSearch(e.target.value)}
							placeholder='Procure no portal...'
							className="w-full h-full border-none pl-6 text-base font-roboto font-medium text-primary dark:text-on-surface-dark outline-none placeholder:text-on-surface-subtle/60 dark:placeholder:text-on-surface-dark-subtle bg-transparent"
							aria-label="Campo de busca"
						/>
						<button
							className="w-16 h-full bg-secondary flex items-center justify-center cursor-pointer border-none"
							type='submit'
							aria-label="Buscar"
						>
							<Search size={22} className="text-primary" />
						</button>
					</form>

					<div className="grid grid-cols-2 w-full gap-3">
						<ButtonMobile href='https://itajai.aprova.com.br/'>Aprova Digital</ButtonMobile>
						<ButtonMobile href='https://servicos.itajai.sc.gov.br/servico/54-nfse.html'>NFS-e</ButtonMobile>
						<ButtonMobile onClick={() => handleQuickService({ label: 'Jornais', url: 'https://servicos.itajai.sc.gov.br/servico/76-jornal_do_municipio_de_itajai.html' })}>Jornais</ButtonMobile>
						<ButtonMobile onClick={() => handleQuickService({ label: 'Webmail', url: 'https://webmail.itajai.sc.gov.br/' })}>Webmail</ButtonMobile>
					</div>
				</div>
			</div>

			{/* Quick Service Modal Mobile */}
			<Modal
				isOpen={!!quickService}
				onClose={() => setQuickService(null)}
				title={quickService?.label || 'Serviço'}
			>
				<div className="flex flex-col gap-6">
					<p className="text-gray-600 dark:text-gray-400 leading-relaxed text-base">
						Você está prestes a acessar o serviço de <strong>{quickService?.label}</strong>.
						Deseja abrir o portal oficial em uma nova aba?
					</p>
					<div className="flex flex-col gap-3">
						<button
							onClick={() => {
								window.open(quickService?.url, "_blank")
								setQuickService(null)
							}}
							className="w-full py-4 bg-primary dark:bg-primary-light text-white font-bold rounded-2xl border-none cursor-pointer active:scale-[0.98] transition-transform"
						>
							Acessar Portal
						</button>
						<button
							onClick={() => setQuickService(null)}
							className="w-full py-4 bg-surface-alt dark:bg-surface-dark-alt text-on-surface dark:text-on-surface-dark font-bold rounded-2xl border-none cursor-pointer active:scale-[0.98] transition-transform"
						>
							Cancelar
						</button>
					</div>
				</div>
			</Modal>
		</section>
	)
}